<ph-stack gap="tight">
    <ph-label *ngIf="section.label">{{ section.label }}</ph-label>
    <ph-data-table [label]="section.label || 'Table'" [columns]="tableColumns" [rows]="tableRows"></ph-data-table>
</ph-stack>
